import React, { Component } from 'react';
import AppContainer from '../AppContainer';
import PBIcon from '../PBIcon';
import NoRecordsFound from '../NoRecordsFound';
import { ERROR_SCREEN_TYPES } from '@progressivebeef/shared/src/constants/AppConstants';
import './style.scss';
import { getLocale } from '@progressivebeef/shared/src/services/storageService/GlobalData';
import localization from '@progressivebeef/shared/src/localization/i18n';
import { Spinner, Modal } from 'reactstrap';
import PDFViewer from '../PDFViewer';
import ActivityHelper from '@progressivebeef/shared/src/helpers/ActivitiesHelper';
import { globalHelper } from '@progressivebeef/shared/src/helpers';

class Preview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      data: null,
      pdfLoading: false,
    };
  }

  componentDidMount() {
    const { imageSource, pdfSource } = this.props;

    // Handle images with headers
    if (imageSource && imageSource.headers) {
      this.renderImage();
    }
    
    // Handle PDFs with headers
    if (pdfSource && pdfSource.headers) {
      this.renderPDF();
    }
  }

  startLoading = () => {
    this.setState({ showLoader: true });
  };

  stopLoading = () => {
    this.setState({ showLoader: false });
  };

  renderPDF = async () => {
    const { pdfSource } = this.props;
    
    if (pdfSource && pdfSource.headers) {
      this.setState({ pdfLoading: true });
      try {
        const data = await globalHelper.getFileFromServer(
          pdfSource.uri,
          pdfSource.headers
        );
        this.setState({ 
          data: data,
          pdfLoading: false
        });
      } catch (error) {
        this.setState({ 
          data: null,
          pdfLoading: false
        });
      }
    }
  };

  renderImage = async () => {
    const { imageSource, isBase64, isComment } = this.props;

    if (!isBase64) {
      var data = await ActivityHelper.getImageFromServer(
        imageSource.uri,
        imageSource.headers,
      );
      this.setState({ data });
    } else
      this.setState({
        data: isComment ? imageSource : `data:image/jpeg;base64,${imageSource}`,
      });
  };

  render() {
    const {
      pdfSource,
      imageSource,
      rightHeader,
      leftHeader,
      title,
      modalVisible,
      type,
      history,
      isComment,
      IconLeftHeader,
      IconRightHeader,
      onRetryPress,
      showPreviousArrow,
      showNextArrow,
      onPreviousPress,
      onNextPress,
      isLoadingNext,
    } = this.props;

    const pdfSourceURL = pdfSource
      ? pdfSource.headers
        ? this.state.data
          ? { base64: this.state.data }
          : null
        : isComment
        ? pdfSource
        : `data:application/pdf;base64,${pdfSource}`
      : null;

    const isLoadedContent =
      pdfSourceURL ||
      (imageSource && (!imageSource.headers || this.state.data));
    const showNoInternet =
      modalVisible &&
      (!(pdfSource || imageSource) ||
        (!navigator.onLine && !isLoadedContent));

    return (
      <>
        <Modal
          className={`attachement-preview-popup${showNoInternet ? ' preview-no-internet-active' : ''}`}
          isOpen={modalVisible}>
          <AppContainer
            title={title || localization[getLocale()].REPORT}
            iconHeader
            hideBottomBar
            IconLeftHeader={IconLeftHeader || (leftHeader && this.renderLeftHeader)}
            IconRightHeader={IconRightHeader || (rightHeader && this.renderRightHeader)}
            history={history}
            noncollapsible>
            <>
              {showNoInternet ? (
                <div className="preview-no-internet">
                  <NoRecordsFound
                    screenType={ERROR_SCREEN_TYPES.NETWORK_ERROR}
                    onButtonPress={onRetryPress}
                  />
                </div>
              ) : (
                <>
                  {this.state.showLoader && (
                    <div style={{ flex: 1 }}>
                      <Spinner color={'rgb(80,45,127)'} animating={true} />
                    </div>
                  )}
                  {pdfSource && !isLoadingNext ? (
                    this.state.pdfLoading ? (
                      <div className="bottom-infinite-loader">
                        <Spinner color={'rgb(80,45,127)'} />
                        <div style={{ textAlign: 'center', marginTop: 10 }}>
                          Loading PDF...
                        </div>
                      </div>
                    ) : pdfSourceURL ? (
                      <div className="tab-screen-scrollable-container pos-relative">
                        <div className="prev-box">
                          <PDFViewer
                            iden="english"
                            source={pdfSourceURL}
                            setFilePath={(filePath) => {
                              this.filePath = filePath;
                            }}
                          />
                        </div>
                      </div>
                    ) : (
                      <div style={{ textAlign: 'center', padding: 40 }}>
                        <div>Failed to load PDF</div>
                      </div>
                    )
                  ) : null}
                  {imageSource && !isLoadingNext ? (
                    imageSource.headers ? (
                      <div className="prev-box">
                        <img
                          alt="description"
                          src={this.state.data}
                          onLoadStart={this.startLoading}
                        />
                      </div>
                    ) : (
                      <div className="prev-box">
                        <img
                          alt="description"
                          src={
                            isComment
                              ? imageSource
                              : `data:${type};base64,${imageSource}`
                          }
                          onLoadStart={this.startLoading}
                        />
                      </div>
                    )
                  ) : null}
                  {showPreviousArrow && (
                    <button
                      type="button"
                      className="preview-nav-arrow preview-nav-arrow-left"
                      onClick={onPreviousPress}
                      aria-label="Previous">
                      <PBIcon name={'chevron-left'} />
                    </button>
                  )}
                  {showNextArrow && (
                    <button
                      type="button"
                      className="preview-nav-arrow preview-nav-arrow-right"
                      onClick={onNextPress}
                      aria-label="Next">
                      <PBIcon name={'chevron-right'} />
                    </button>
                  )}
                  {isLoadingNext && (
                    <div className="preview-nav-loading-overlay">
                      <Spinner color={'rgb(80,45,127)'} />
                    </div>
                  )}
                </>
              )}
            </>
          </AppContainer>
        </Modal>
      </>
    );
  }

  renderLeftHeader = () => {
    return (
      <div className="head-icon left-align">
        <PBIcon
          name={'chevron-left'}
          onPress={() => {
            this.props.history.goBack();
          }}
        />
      </div>
    );
  };

  renderRightHeader = () => {
    return (
      <div className="head-icon right-align">
        <PBIcon name={'times'} onPress={this.props.onRightIconPress} />
      </div>
    );
  };
}

export default Preview;
